import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Label } from '../ui/label';

/**
 * Reusable tag input — chips with remove buttons. Submits on Enter or "Agregar".
 * Used in both Agency and Agent dashboards.
 *
 * Props:
 *   label, value (array of strings), onChange (newArray => void),
 *   placeholder, testid (base test id, fields will be `${testid}-input` etc.)
 */
export default function TagsField({ label, value, onChange, placeholder, testid }) {
  const list = Array.isArray(value) ? value : [];
  const [draft, setDraft] = useState('');
  const add = () => {
    const t = draft.trim();
    if (!t) return;
    if (list.includes(t)) { setDraft(''); return; }
    onChange([...list, t]);
    setDraft('');
  };
  const remove = (i) => onChange(list.filter((_, idx) => idx !== i));

  return (
    <div>
      <Label className="text-xs uppercase tracking-widest text-gray-500">{label}</Label>
      <div className="flex gap-2 mt-1.5">
        <Input
          value={draft}
          onChange={e => setDraft(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); add(); } }}
          placeholder={placeholder}
          className="h-10 flex-1"
          data-testid={`${testid}-input`}
        />
        <Button type="button" onClick={add} variant="outline" className="h-10 rounded-full" data-testid={`${testid}-add`}>Agregar</Button>
      </div>
      <div className="flex flex-wrap gap-1.5 mt-2">
        {list.map((t, i) => (
          <span key={`${t}-${i}`} className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-habita-mint text-habita text-xs font-semibold" data-testid={`${testid}-chip-${i}`}>
            {t}
            <button onClick={() => remove(i)} className="hover:bg-habita hover:text-white rounded-full p-0.5" aria-label={`Quitar ${t}`}>
              <X className="w-2.5 h-2.5" />
            </button>
          </span>
        ))}
      </div>
    </div>
  );
}
